//dependencies
import React from "react";

//components
import FilterChips from "../../../../../../../components/FilterChips";
import { Filter } from "../../../../../../../components/FilterChips/FilterChips";

import { ReviewsOfMe360ReviewsOptions, ReviewsOfMeFilters, ReviewsOfMeStatusOptions } from "../ReviewsOfMeFilterPanel";

const convertFiltersToReadableList = (filters?: ReviewsOfMeFilters) => {
	const readableList: Filter[] = [];

	// Process easyAddStatus filter
	if (filters?.easyAddStatus) {
		const easyAddStatusLabel = ReviewsOfMe360ReviewsOptions.find(
			(option) => option.value === filters.easyAddStatus
		)?.label;
		if (easyAddStatusLabel) {
			readableList.push({
				id: "easyAddStatus",
				type: "string",
				label: "360 Status",
				value: easyAddStatusLabel,
			});
		}
	}

	// Only show status chip if it's not "any"
	const statusValue = filters?.status || "any";
	if (statusValue !== "any") {
		const statusLabel = ReviewsOfMeStatusOptions.find((option) => option.value === statusValue)?.label;
		if (statusLabel) {
			readableList.push({
				id: "status",
				type: "string",
				label: "Status",
				value: statusLabel,
			});
		}
	}

	return readableList;
};

type ReviewsOfMeReadableFiltersListProps = {
	filters: ReviewsOfMeFilters;
	setFilters: (newFilters) => void;
};
const disabledFilters = [{ id: "status", value: "Any", label: "Status", type: "string" as const }];

const ReviewsOfMeReadableFilters = ({ filters, setFilters }: ReviewsOfMeReadableFiltersListProps) => {
	const statusValue = filters?.status || "any";
	const hasOtherFilters = filters?.easyAddStatus;

	// Hide filters bar if status is "any" and there are no other filters
	if (statusValue === "any" && !hasOtherFilters) {
		return null;
	}

	const convertedFilters = convertFiltersToReadableList(filters);
	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<FilterChips
			filters={convertedFilters}
			label="Filters applied: "
			disabledFilters={disabledFilters}
			onDeleteFilter={(id) => {
				const newFilters = { ...filters };
				// Remove status from filters (don't set to "any" as that would add it to URL)
				delete newFilters[id];
				// Remove undefined values to clean up the object
				Object.keys(newFilters).forEach((key) => {
					if (newFilters[key] === undefined) {
						delete newFilters[key];
					}
				});
				setFilters(newFilters);
			}}
		/>
	);
};

export default ReviewsOfMeReadableFilters;
